module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticStyle: {
      "display": "none"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PP1.w.1.0.0"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "flow"
  }, [_c('a', {
    staticClass: "page",
    attrs: {
      "id": "ORIG-GBS.PA6"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "gtxt_body",
    attrs: {
      "id": "block.9.0.0.box.740.502.244.50.q.80"
    }
  }, [_c('a', {
    attrs: {
      "id": "ORIG-GBS.PA6.w.0.0.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body gtxt_heading",
    staticStyle: {
      "text-align": "center",
      "font-variant": "small-caps"
    },
    attrs: {
      "id": "para.9.0.0.box.740.502.244.50.q.80"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PP1.w.2.0.0"
    }
  }), _vm._v("Rosters")]), _c('a', {
    attrs: {
      "id": "GBS.PP2"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PP2.w.0.0.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PP2.w.0.1.0"
    }
  })]), _c('a', {
    attrs: {
      "id": "GBS.PP2.w.0.2.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PP2.w.0.3.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PP2.w.0.4.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PP2.w.0.5.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PP2.w.0.6.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PP2.w.0.7.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PP2.w.0.8.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PP2.w.0.9.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PP2.w.0.10.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PP2.w.0.11.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PP2.w.0.12.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PP2.w.1.0.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PP3"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PP3.w.0.0.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PP3.w.1.0.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PP3.w.2.0.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PP3.w.3.0.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PP3.w.4.0.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PP3.w.5.0.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PP3.w.6.0.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PP3.w.7.0.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PP3.w.7.1.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PP3.w.7.2.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PP3.w.8.0.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PP3.w.9.0.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PP3.w.10.0.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PP3.w.11.0.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PP3.w.12.0.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PP3.w.13.0.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PP3.w.14.0.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PP3.w.15.0.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PP3.w.16.0.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PP3.w.17.0.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PP3.w.17.1.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PP3.w.18.0.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PP3.w.19.0.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PP3.w.20.0.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PP3.w.21.0.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PP3.w.22.0.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PP3.w.23.0.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PP3.w.24.0.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PP3.w.25.0.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PP3.w.26.0.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PP3.w.27.0.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PP3.w.28.0.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PP3.w.29.0.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PP3.w.30.0.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PP3.w.31.0.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PP3.w.31.1.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PP3.w.31.2.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PP3.w.31.3.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PP3.w.31.4.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PP3.w.31.5.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PP3.w.31.6.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PP3.w.31.7.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PP3.w.31.8.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PP3.w.31.9.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PP3.w.31.10.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PP3.w.32.0.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PP3.w.33.0.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PP3.w.34.0.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PP3.w.35.0.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PP3.w.36.0.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PP3.w.37.0.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PP3.w.38.0.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PP3.w.39.0.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PP3.w.40.0.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PP3.w.40.1.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PP3.w.41.0.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PP3.w.42.0.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PP3.w.43.0.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PP4"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PP4.w.0.0.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA1"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA1.w.0.0.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA1.w.1.0.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA2"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA2.w.0.0.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA3"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA3.w.0.0.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA3.w.1.0.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA3.w.2.0.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA3.w.2.1.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA3.w.3.0.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA3.w.4.0.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA3.w.5.0.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA4"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA4.w.0.0.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA4.w.1.0.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA4.w.1.1.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA4.w.2.0.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA4.w.3.0.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA4.w.4.0.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA4.w.4.1.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA4.w.5.0.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA4.w.6.0.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA4.w.7.0.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA4.w.8.0.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA4.w.9.0.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA5"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA5.w.0.0.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA5.w.1.0.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA5.w.2.0.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA5.w.3.0.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA5.w.4.0.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA5.w.5.0.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA5.w.5.1.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA5.w.5.2.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA5.w.5.3.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA5.w.5.4.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA5.w.5.5.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA5.w.5.6.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA5.w.5.7.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA5.w.5.8.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA5.w.5.9.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA5.w.6.0.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA5.w.7.0.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA5.w.8.0.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA5.w.9.0.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA6"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA6.w.0.0.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA6.w.1.0.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA6.w.2.0.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA6.w.3.0.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA6.w.4.0.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA6.w.5.0.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA6.w.6.0.0"
    }
  }), _vm._v(" "), _c('a', {
    attrs: {
      "id": "GBS.PA6.w.6.0.0.1"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA6.w.6.0.0.2"
    }
  }), _c('div', {
    staticClass: "gimg_table",
    attrs: {
      "id": "block.9.1.0.box.214.973.1290.843.q.50"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA6.w.6.0.0.3"
    }
  }), _c('img', {
    staticStyle: {
      "max-width": "100%",
      "max-height": "100%"
    },
    attrs: {
      "alt": "[table]",
      "src": "data/content-0008.png"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA6.w.6.0.0.4"
    }
  })])]), _c('div', {
    staticStyle: {
      "display": "none"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA7"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA7.w.0.0.0"
    }
  })]), _vm._v(" "), _c('div', {
    staticStyle: {
      "display": "none"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA7.w.0.0.0.1"
    }
  })])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-965ac52c","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/content/content0009.vue
// module id = 57
// module chunks = 0